import { proxy } from "valtio";

let chartStore = proxy({
    productChartFull: false,
    comboChartFull: false,
    pieChartFull: false,
    activeProduct: 'LCL'
})

export default chartStore